import React from 'react';

import { AngularDirective } from '../../../common/react/components/AngularDirective';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';

export interface CustomizationSettingsSubspaceProps extends ReactDirectiveProps {}

export function CustomizationSettingsSubspace(props: CustomizationSettingsSubspaceProps) {
  return (
    <div className={'tb-stylish-settings'}>
      <AngularDirective
        angularContext={props.angularContext}
        template={'<tb:settings-coordinator><tb:customization-settings-form /></tb:settings-coordinator>'}
      />
    </div>
  );
}
